module.exports = __webpack_public_path__ + "static/media/flat-mesh.20b1064b.svg";